import * as React from "react";
import { memo, SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  const { width = 16, height = 16 } = props;
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14.471 10.7"
      fill="none"
    >
      <path
        fill="#0E0E0E"
        d="M7.236 0a7.36 7.36 0 0 1 7.235 6.02A7.36 7.36 0 0 1 0 6.02 7.36 7.36 0 0 1 7.236 0Zm0 10.7a6.022 6.022 0 0 0 5.87-4.68 6.023 6.023 0 0 0-11.74 0 6.022 6.022 0 0 0 5.87 4.68Zm0-1.671a3.01 3.01 0 1 1 0-6.02 3.01 3.01 0 0 1 0 6.02Zm0-1.338a1.672 1.672 0 1 0 0-3.344 1.672 1.672 0 0 0 0 3.344Z"
      />
    </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as EyeOn };
